import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Auth
import { db } from "./../firebase";

function* handleSync(action) {
  const { filter } = action.meta;
  if (filter === "updateClient") {
    const { cUID } = action.meta;
    const clientSnapshot = yield db.onceGetClient(cUID);

    yield put({
      type: ACTIONS.UPDATE_CLIENT,
      payload: clientSnapshot.val()
    });
  }
}

export function* syncWatcher() {
  yield takeEvery(ACTIONS.SYNC, handleSync);
}



// WEBPACK FOOTER //
// ./src/sagas/sync.js